export default __webpack_public_path__ + "static/media/cover.f8d4e609.jpg";